// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[dir] .main[data-v-78d5c2e6] {\n  padding: 20px;\n}\n.swal-actions-spacing[data-v-78d5c2e6] {\n  display: flex;\n  justify-content: center;\n  /* Align buttons in the center */\n  gap: 15px;\n  /* Adjust space between buttons */\n}\n\n/* Optional: Adjust individual button margins */\n[dir] .swal-confirm-btn[data-v-78d5c2e6] {\n  padding: 8px 16px;\n}\n[dir] .swal-cancel-btn[data-v-78d5c2e6] {\n  padding: 8px 16px;\n}\n", ""]);
// Exports
module.exports = exports;
